import { Theme } from '@mui/material';
import Accordion from './Accordion';
import Autocomplete from './Autocomplete';
import Backdrop from './Backdrop';
import Button from './Button';
import Calendar from './Calendar';
import Card from './Card';
import Input from './Input';
import Paper from './Paper';
import Tabs from './Tabs';
import Tooltip from './Tooltip';
import Alert from './Alert';
import Dialog from './Dialog';
import DateTimePicker from './DateTimePicker';

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(
    Button(theme),
    Card(theme),
    Tooltip(theme),
    Backdrop(theme),
    Input(theme),
    Accordion(theme),
    Tabs(theme),
    Autocomplete(theme),
    Paper(),
    Calendar(theme),
    Alert(theme),
    Dialog(),
    DateTimePicker(),
  );
}
